export { default } from 'features/partners-walmart/routes/partnerships-route';
